module.exports = __webpack_public_path__ + "img/china.613b181c.jpg";